module.exports = __webpack_public_path__ + "img/V1bottom.086d5c8f.png";